/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexVariantDto } from '../../models/backend-capex-variant-dto';
import { BackendPatchedCapexVariantRequestDto } from '../../models/backend-patched-capex-variant-request-dto';

export interface EconomicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded$Params {
  /**
   * A unique integer value identifying this capex variant.
   */
  id: number;
  body?: BackendPatchedCapexVariantRequestDto;
}

export function economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexVariantDto>;
    }),
  );
}

economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded.PATH = '/api/economic_indicators/capex_variants/{id}/';
